<template>
  <div>
    <div class="modalBackColor" :class="{ result_open: clickBonus }"></div>
    <!-- [모달창]일일,주간,월간 보너스 내역 -->
    <div ref="scrollContainer" class="modal_wrap h80 modal_no235" data-modal="235" :class="{ result_open: clickBonus }">
      <div class="modal_title">
        {{ $t("mypage.bonusHistory") }}
        <div class="mdcolsebtn" @click="closeBonus"></div>
      </div>
      <div class="modal_content">
        <div class="bonus_wrap">
          <form>
            <!-- 일 | 주 | 년 탭 : start -->
            <div class="taplink">
              <a @click="changeTab(1)" :class="{ active: selectTab === 1 }">{{
                $t("mypage.today")
                }}</a>
              <a @click="changeTab(2)" :class="{ active: selectTab === 2 }">{{
                $t("mypage.weekly")
                }}</a>
              <a @click="changeTab(3)" :class="{ active: selectTab === 3 }">{{
                $t("mypage.monthly")
                }}</a>
            </div>
            <!-- 일 | 주 | 년 탭 : end -->
          </form>
          <!-- 보너스 리스트 : start -->
          <div class="table_wrap">
            <table class="modal_table_1">
              <tbody>
                <tr>
                  <!-- <th>Number</th> -->
                  <th>{{ $t("mypage.paymentDate") }}</th>
                  <th>{{ $t("mypage.price") }}</th>
                  <th>{{ $t("mypage.item") }}</th>
                </tr>
              </tbody>
              <tbody v-if="bonusList.length === 0" class="table-body">
                <tr>
                  <td colspan="4">{{ $t("mypage.noData") }}</td>
                </tr>
              </tbody>
              <tbody v-if="bonusList.length > 0" class="table-body">
                <tr v-for="(bonus, i) in bonusList" :key="i">
                  <!-- <td>{{ i }}</td> -->
                  <td>{{ bonus.Date }}</td>
                  <td class="amount">${{ Number(bonus.amount).toLocaleString() }}</td>
                  <td class="amount">{{ bonus.title }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- 보너스 리스트 : end -->
          <div class="change_page" v-if="totalPages == 1">
            <span>{{ totalPages }}</span>
          </div>
          <div class="change_page" v-else-if="totalPages > 1">
            <button v-if="nowPage > 1" @click="prePage">&lt;</button>
            <span>{{ nowPage }} / {{ totalPages }}</span>
            <button v-if="nowPage < totalPages" @click="nextPage">&gt;</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- [모달창]일일,주간,월간 보너스 내역:End -->
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  name: "BonusDetail",
  data() {
    return {
      selectTab: 1, // 선택한 탭
      bonusList: [], // 히스토리 list

      postPerPage: 20, // 페이지당 보여줄 수
      totalPages: 0, // 총 페이지 수
    };
  },
  async created() {
    await this.getDaily();
    this.bonusList = this.dailyList;
    this.totalPages = this.dailyPages;
    // console.log('bonusList', this.bonusList)
    // console.log('totalPages', this.totalPages)
  },
  computed: {
    ...mapState("user", [
      "clickBonus",
      "dailyList",
      "weeklyList",
      "monthlyList",
      "nowPage",
      "language",
      "dailyPages",
      "weeklyPages",
      "monthlyPages",
    ]),

    displayedPosts() {
      // 현재 페이지에 해당하는 게시글 목록을 반환하는 computed 속성
      const startIndex = (this.nowPage - 1) * this.postsPerPage;
      const endIndex = startIndex + this.postsPerPage;
      return this.bonusList.slice(startIndex, endIndex);
    },
  },
  emits: ['getDashboard'],
  methods: {
    ...mapMutations("user", ["changeBonus", "changePage"]),
    ...mapActions("user", ["getDaily", "getWeekly", "getMonthly"]),

    closeBonus() {
      this.changeBonus({ state: false });
      this.$emit('getDashboard');
    },
    // 일 | 주 | 년 탭 변경시 실행 함수
    async changeTab(tabId) {
      this.selectTab = tabId;
      if (tabId === 1) {
        this.changePage(1);
        this.tabChange(1);
      } else if (tabId === 2) {
        this.changePage(1);
        this.tabChange(2);
      } else if (tabId === 3) {
        this.changePage(1);
        this.tabChange(3);
      }
    },
    // 탭 id 마다 해당 api 호출 함수
    async tabChange(tabId) {
      if (tabId === 1) {
        await this.getDaily();
        this.bonusList = this.dailyList;
        this.totalPages = this.dailyPages;
      } else if (tabId === 2) {
        await this.getWeekly();
        this.bonusList = this.weeklyList;
        this.totalPages = this.weeklyPages;
      } else if (tabId === 3) {
        await this.getMonthly();
        this.bonusList = this.monthlyList;
        this.totalPages = this.monthlyPages;
      }
    },
    async scrollToTop() {
      await this.$nextTick();
      if (this.$refs.scrollContainer) {
        this.$refs.scrollContainer.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }
    },
    // 이전 페이지
    prePage() {
      this.changePage(this.nowPage - 1);
      this.tabChange(this.selectTab);
      this.scrollToTop();
    },
    // 다음 페이지
    nextPage() {
      this.changePage(this.nowPage + 1);
      this.tabChange(this.selectTab);
      this.scrollToTop();
    },
  },
};
</script>

<style scoped>
.result_open {
  display: block;
}

.change_page {
  width: 150px;
  margin: auto;
  text-align: center;
  padding-top: 15px;
}

.change_page button {
  color: white;
  padding: 2px 10px 0 10px;
}

.change_page span {
  margin-top: 10px;
}
</style>
